import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrosolicitante'
})
export class FiltrosolicitantePipe implements PipeTransform {

  transform(value: any, args: any, usuariomx: boolean, numidusuario: string): any {
    const resultPost = [];
    for ( const post of value) {
      if (usuariomx) {
        console.log ("es un user sportfishing");
        if (numidusuario == post.usermx){
        if (post.enviadoporemail === false) {
                  resultPost.push (post);
                }
        }
        

      } else {
        if (usuariomx==false) {
      if (post.enviadoporemail === false) {
        resultPost.push (post);
      }
      }
     
    }

    

  }
  return resultPost;
}
}
